import { Card, CardContent, Grid, Typography } from "@mui/material";
import SensitiveValueField from "./SensitiveFields";
import { YouTubeChannel } from "../youtubechannel.types";

interface Props {
  channel: YouTubeChannel;
}

export default function ChannelOAuthSection({ channel }: Props) {
  return (
    <Card sx={{ boxShadow: 0 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          OAuth Credentials
        </Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <SensitiveValueField
              label="Client ID"
              value={channel.client_id}
              multiline
              rows={2}
              masked={false}
              helperText="View only"
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <SensitiveValueField
              label="Client Secret"
              value={channel.client_secret}
              multiline
              rows={3}
              masked
              helperText="Sensitive field. View only."
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <SensitiveValueField
              label="Refresh Token"
              value={channel.refresh_token}
              multiline
              rows={4}
              masked
              helperText="Sensitive field. View only."
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <SensitiveValueField
              label="Access Token Preview"
              value={channel.access_token_preview}
              masked
              helperText="Preview only"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <SensitiveValueField
              label="Token URI"
              value={channel.token_uri}
              masked={false}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <SensitiveValueField
              label="Token Expiry"
              value={channel.token_expiry}
              masked={false}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <SensitiveValueField
              label="Created At"
              value={channel.created_at}
              masked={false}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
